import { render } from "./StaffFullInfo.vue?vue&type=template&id=258fe8de&scoped=true"
import script from "./StaffFullInfo.vue?vue&type=script&lang=js"
export * from "./StaffFullInfo.vue?vue&type=script&lang=js"

import "./StaffFullInfo.vue?vue&type=style&index=0&id=258fe8de&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258fe8de"]])

export default __exports__